import React from "react";
import Sidebar from "../components/sidebar/Sidebar";
import EachWorkflow from "../components/eachWorkflow/EachWorkflow";
import { useLocation } from "react-router-dom";

// EachWorkflowPage component renders the interface for a specific workflow with a sidebar and workflow content.
// It receives an openDrawer prop to control the sidebar drawer and extracts user data from the location state.
const EachWorkflowPage = ({ openDrawer }) => {
  // useLocation hook provides access to the location object, which contains the state passed through navigation.
  const location = useLocation();

  // UserData object extracts user-specific data from the location state for rendering and authentication purposes.
  const UserData = {
    roles: location.state?.roles, // User roles (e.g., admin, user)
    isAdmin: location.state?.isAdmin, // Boolean flag indicating if the user is an admin
    isAuthenticated: location.state?.isAuthenticated, // Boolean flag indicating if the user is authenticated
    refreshToken: location.state?.refreshToken, // Token used to refresh user session
    accessToken: location.state?.accessToken, // Token used for API requests
    userId: location.state?.userId, // Unique identifier for the user
    username: location.state?.username, // Username of the authenticated user
  };

  return (
    <>
      {/* Sidebar component with openDrawer and userData props. 
          The 'active' prop indicates the active menu item in the sidebar (5 in this case). */}
      <Sidebar openDrawer={openDrawer} userData={UserData} active={6} />

      {/* EachWorkflow component that renders the main content for a specific workflow. 
          It also receives the openDrawer and userData props. */}
      <EachWorkflow openDrawer={openDrawer} userData={UserData} />
    </>
  );
};

export default EachWorkflowPage;
